import React, { useState,useEffect } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { CuttingList } from '../TitleList';
import styled, { cutDates, inputImages, inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';

import Divider from '@mui/material/Divider';
import { useLocation } from 'react-router-dom';

const CutManuallyEntry = () => {

    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        memoNo: '',
        master: '',
        mono: '',
        item: '',
        size: '',
        panna: '',
        cloth: '',
        mstkmtr: '',
        mreqmtr: '',
        mtch1: '',
        m1stkmtr: '',
        m1reqmtr: '',
        mtch2: '',
        m2stkmtr: '',
        m2reqmtr: '',
        mtch3: '',
        m3stkmtr: '',
        m3reqmtr: '',
        totqty: '',
        party: '',
        logo: '',
        schl: '',
        userId: '1'
    });

    const dispatch = useDispatch();
    // const location = useLocation();
    // const { form } = location.state || {};

    useEffect(() => {
        // Retrieve the URL parameters
        const query = new URLSearchParams(window.location.search);
        const formParam = query.get('form');

        if (formParam) {
            try {
                // Parse the form data
                const parsedForm = JSON.parse(decodeURIComponent(formParam));
                console.log(parsedForm);
            } catch (error) {
                console.error('Error parsing form data:', error);
            }
        }
    }, []);
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });

    };
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };




    const handleSubmit = (e) => {
        e.preventDefault();
        // let finalObject = convertIntoOneObject(tableRows, formData);

        // dispatch(createPOEntry(finalObject))
        //     .unwrap()
        //     .then((result) => {
        //         // Handle success
        //         console.log('POST request successful!', result);
        //         toast.success("Purchase Order Added");
        //         window.location.reload();
        //         // You may want to update your component state or perform any other action
        //     })
        //     .catch((error) => {
        //         // Handle error
        //         console.error('Error while making POST request:', error);
        //         // You may want to display an error message to the user or perform any other action
        //     });

    };

    return (
        <>
            <Titlebar data={CuttingList} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Cutting Manually Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Memo No', name: 'memoNo' }

                                ].map((field, index) => (
                                    <Grid item xs={12} md={4} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '28%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} md={4}>
                                    <Grid container alignItems="center" spacing={0.5}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="master">Cutting Master:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="master"
                                                    id="master"
                                                    name="master"
                                                    value={formData.master}
                                                    onChange={(e) => handleDropdownChange(e, 'master')}
                                                    sx={cutDates}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>

                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={12} sx={{ mt: 2, mb: 2 }}>
                                    <Divider />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="mono">Manual Order No:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="mono"
                                                    id="mono"
                                                    name="mono"
                                                    value={formData.mono}
                                                    onChange={(e) => handleDropdownChange(e, 'mono')}
                                                    sx={cutDates}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>

                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}></Grid>


                                <Grid item xs={12} md={4}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="item">Item:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="item"
                                                    id="item"
                                                    name="item"
                                                    value={formData.item}
                                                    onChange={(e) => handleDropdownChange(e, 'item')}
                                                    sx={cutDates}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>

                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {[
                                    { label: 'Size', name: 'size', type: 'readOnly' },
                                    { label: 'Panna', name: 'panna', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={4} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '28%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                        sx={cutDates}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                <Grid item xs={12} md={4}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="cloth">Cloth:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="cloth"
                                                    id="cloth"
                                                    name="cloth"
                                                    value={formData.cloth}
                                                    onChange={(e) => handleDropdownChange(e, 'cloth')}
                                                    sx={cutDates}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>

                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {[
                                    { label: 'Stock Mtr', name: 'mstkmtr' },
                                    { label: 'Required Mtr', name: 'mreqmtr' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={4} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '28%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                        sx={cutDates}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}



                                <Grid item xs={12} md={4}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="mtch1">Match-1 :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="mtch1"
                                                    id="mtch1"
                                                    name="mtch1"
                                                    value={formData.mtch1}
                                                    onChange={(e) => handleDropdownChange(e, 'mtch1')}
                                                    sx={cutDates}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>

                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {[
                                    { label: 'Stock Mtr', name: 'm1stkmtr' },
                                    { label: 'Required Mtr', name: 'm1reqmtr' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={4} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '28%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                        sx={cutDates}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}
                                <Grid item xs={12} md={4}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="mtch2">Match-2 :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="mtch2"
                                                    id="mtch2"
                                                    name="mtch2"
                                                    value={formData.mtch2}
                                                    onChange={(e) => handleDropdownChange(e, 'mtch2')}
                                                    sx={cutDates}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>

                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {[
                                    { label: 'Stock Mtr', name: 'm2stkmtr' },
                                    { label: 'Required Mtr', name: 'm2reqmtr' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={4} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '28%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                        sx={cutDates}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}
                                <Grid item xs={12} md={4}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="mtch3">Match-3 :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="mtch3"
                                                    id="mtch3"
                                                    name="mtch3"
                                                    value={formData.mtch3}
                                                    onChange={(e) => handleDropdownChange(e, 'mtch3')}
                                                    sx={cutDates}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>

                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {[
                                    { label: 'Stock Mtr', name: 'm3stkmtr' },
                                    { label: 'Required Mtr', name: 'm3reqmtr' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={4} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '28%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                        sx={cutDates}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}
                                <Grid item xs={12} md={12} sx={{ mt: 2, mb: 2 }}>
                                    <Divider />
                                </Grid>

                                {[
                                    { label: 'Total Qty', name: 'totqty', type: 'readOnly' },
                                    { label: 'Party', name: 'party', type: 'readOnly' },
                                    { label: 'Logo', name: 'logo', type: 'readOnly' },
                                    { label: 'School', name: 'schl', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                        sx={inputStyles}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}



                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>


                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default CutManuallyEntry;
